<template>
  <div class="information_details">
    <div class="top">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/BillingInformation' }"
          >企业增值税开票信息</el-breadcrumb-item
        >
        <el-breadcrumb-item>查看开票信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <table border="1" cellspacing="0" cellpadding="0">
        <tr>
          <td>单位名称:</td>
          <td>
            {{ form.name }}
          </td>
        </tr>
        <tr>
          <td>企业地址:</td>
          <td>
            {{ form.area }}
          </td>
        </tr>
        <tr>
          <td>纳税人识别号:</td>
          <td>
            {{ form.code }}
          </td>
        </tr>
        <tr>
          <td>是否一般纳税人:</td>
          <td>
            {{ form.isTaxpayer == 1 ? "是" : "否" }}
          </td>
        </tr>
        <tr>
          <td>企业开户行名称:</td>
          <td>
            {{ form.bank }}
          </td>
        </tr>
        <tr>
          <td>企业开户行账号:</td>
          <td>
            {{ form.bankNumber }}
          </td>
        </tr>
        <tr>
          <td>企业电话:</td>
          <td>
            {{ form.phone }}
          </td>
        </tr>
        <tr>
          <td>企业联系人:</td>
          <td>
            {{ form.linkman }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { httpReceiptEdit } from "../../utils/personalsetting";
export default {
  data() {
    return {
      form: {
        name: " ",
        area: "",
        code: "",
        isTaxpayer: "",
        bank: "",
        bankNumber: "",
        phone: "",
        linkman: "",
      },
    };
  },
  methods: {
    //查看增值税开票信息
    _httpReceiptEdit(receipt_id) {
      httpReceiptEdit(receipt_id).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.form.name = data.data.enterprise_name;
          this.form.area = data.data.register_address;
          this.form.code = data.data.organization_code;
          this.form.isTaxpayer = data.data.is_enterprise;
          this.form.bank = data.data.bank_name;
          this.form.bankNumber = data.data.bank_number;
          this.form.phone = data.data.contact_phone;
          this.form.linkman = data.data.contact_name;
        } else {
          this.$message(data.msg);
        }
      });
    },
  },
  watch: {},
  mounted() {
    this._httpReceiptEdit(this.$route.query.id);
  },
};
</script>

<style lang="scss" scoped>
.information_details {
  .top {
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;
  }
  .main {
    table {
      width: 100%;
      height: 200px;
      margin-top: 20px;
      border: 1px solid #eee;
      tr {
        td {
          height: 70px;
          padding: 0 15px;
        }
        td:first-of-type {
          width: 30%;
        }
      }
    }
  }
}
</style>